
import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';

export default function About() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const highlights = [
    {
      icon: 'ri-building-line',
      title: 'Own Manufacturing Unit',
      description: 'State-of-the-art facility with modern infrastructure and advanced machinery'
    },
    {
      icon: 'ri-award-line',
      title: 'Commitment to Quality and Innovation',
      description: 'Strict quality assurance standards and continuous improvement processes'
    },
    {
      icon: 'ri-team-line',
      title: 'Experienced Team and Infrastructure',
      description: 'Skilled professionals with years of expertise in chemical manufacturing'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer-Centric Approach',
      description: 'Dedicated to meeting client requirements with personalized solutions'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative pt-24 pb-20 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 62, 126, 0.85), rgba(0, 62, 126, 0.7)), url('https://readdy.ai/api/search-image?query=Shree%20Govardhan%20Chemicals%20manufacturing%20plant%20exterior%2C%20modern%20chemical%20factory%20building%2C%20industrial%20facility%20Gujarat%20India%2C%20magnesium%20carbonate%20production%20unit%2C%20corporate%20headquarters%20with%20company%20signage%2C%20professional%20industrial%20architecture&width=1920&height=600&seq=sgc-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-6 text-center text-white">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">About Shree Govardhan Chemicals</h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
              Leading manufacturer of Light Magnesium Carbonate with commitment to excellence and safety
            </p>
          </div>
        </div>
      </section>

      {/* Company Profile */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-8">Company Profile</h2>
              <div className="space-y-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  Shree Govardhan Chemicals is one of the reputed manufacturer of <strong>LIGHT MAGNESIUM CARBONATE (MgCO3)</strong>. Our factory site located at Survey No. 63/1 P-2, Near Ahmadabad-Bhavnagar National Highway, Sanes – 364313, Dist-Bhavnagar- Gujarat.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  We have highly experienced team for manage of high quality materials supply to our customers. We are all activities managing with slogan of:
                </p>
                <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-6 rounded-xl border-l-4 border-blue-600">
                  <p className="text-xl font-bold text-blue-800 text-center">
                    "SAFETY FIRST – QUALITY OF PRODUCTION MUST"
                  </p>
                </div>
                <p className="text-lg text-gray-700 leading-relaxed">
                  We Promise to maintain the same commitment to quality in years to come. Magnesium carbonate is produced using high quality raw materials. Production facility is well equipped and well designed with Safety in and around production area.
                </p>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Shree%20Govardhan%20Chemicals%20factory%20building%2C%20light%20magnesium%20carbonate%20manufacturing%20plant%2C%20industrial%20facility%20with%20company%20logo%2C%20modern%20chemical%20production%20unit%2C%20Gujarat%20industrial%20complex%2C%20professional%20corporate%20building&width=600&height=500&seq=sgc-building&orientation=portrait"
                alt="Shree Govardhan Chemicals Factory"
                className="w-full h-96 object-cover rounded-xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-lg">
                <div className="text-center">
                  <p className="text-2xl font-bold text-blue-600">15+</p>
                  <p className="text-sm text-gray-600">Years Experience</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Management Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-800 mb-12 text-center">Management Excellence</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20management%20team%20meeting%2C%20chemical%20industry%20executives%2C%20business%20professionals%20in%20modern%20office%2C%20corporate%20leadership%20team%2C%20industrial%20management%20discussion%2C%20professional%20workplace%20environment&width=600&height=400&seq=sgc-management&orientation=landscape"
                  alt="Management Team"
                  className="w-full h-80 object-cover rounded-xl shadow-lg"
                />
              </div>
              <div className="space-y-6">
                <div className="bg-white rounded-xl p-8 shadow-lg">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-user-star-line text-blue-600 mr-3"></i>
                    Dynamic Leadership
                  </h3>
                  <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    Shree Govardhan Chemicals management being sensitive to changing customer requirement is very dynamic, flexible, and open to new ideas.
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    Customer can deal with direct senior management personnel who ensure quality responds in terms of products.
                  </p>
                </div>
                <div className="bg-white rounded-xl p-8 shadow-lg">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-team-line text-blue-600 mr-3"></i>
                    Expert Team
                  </h3>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    Shree Govardhan Chemicals has a team of highly qualified and skilled professionals, who are committed to excellence in terms of product quality, productivity, cost-efficiency and delivery.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=global%20business%20expansion%2C%20world%20map%20with%20connection%20lines%2C%20international%20trade%20network%2C%20chemical%20industry%20global%20reach%2C%20export%20import%20business%2C%20worldwide%20distribution%20network&width=1920&height=600&seq=sgc-vision&orientation=landscape')`
          }}
        ></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8">Our Vision</h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-xl text-blue-100 leading-relaxed">
                Our vision to expand our market domestic as well as globally by providing surety of product and quality assurance to our valuable customers.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-global-line text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">Global Expansion</h3>
                <p className="text-blue-100">Reaching international markets</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">Quality Assurance</h3>
                <p className="text-blue-100">Guaranteed product excellence</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-2-line text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">Customer Focus</h3>
                <p className="text-blue-100">Dedicated to client satisfaction</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Highlights Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Core Strengths</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">What sets us apart in the chemical manufacturing industry and makes us the preferred choice for quality magnesium carbonate</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {highlights.map((item, index) => (
              <Card key={index} className="p-8 hover:shadow-xl transition-shadow duration-300">
                <div className="flex items-start space-x-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center text-white text-2xl flex-shrink-0">
                    <i className={item.icon}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3">{item.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{item.description}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Facility Details */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-800 mb-12 text-center">Our Manufacturing Facility</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div className="bg-white rounded-xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                  <i className="ri-map-pin-line text-blue-600 mr-3"></i>
                  Strategic Location
                </h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Our state-of-the-art manufacturing facility is strategically located in Bhavnagar, Gujarat, providing excellent access to raw materials and distribution networks across India.
                </p>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <i className="ri-building-line text-blue-600 mt-1"></i>
                    <div>
                      <p className="font-semibold text-gray-800">Complete Address:</p>
                      <p className="text-gray-600">Survey No. 63/1 P-2, Near Ahmadabad-Bhavnagar National Highway, Sanes – 364313, Dist. Bhavnagar, Gujarat, India</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-road-map-line text-blue-600"></i>
                    <p className="text-gray-600">Easy highway access for efficient logistics</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-truck-line text-blue-600"></i>
                    <p className="text-gray-600">Optimal location for pan-India distribution</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                  <i className="ri-shield-check-line text-blue-600 mr-3"></i>
                  Quality Standards
                </h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  We maintain the highest standards of quality control throughout our manufacturing process, ensuring consistency, purity, and safety in every batch of magnesium carbonate produced.
                </p>
                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <p className="text-gray-700">Safety First Approach in all operations</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <p className="text-gray-700">Premium High Quality Raw Materials</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <p className="text-gray-700">Well Equipped Modern Production Facility</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <p className="text-gray-700">Comprehensive Safety Measures</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <p className="text-gray-700">Rigorous Quality Testing Protocols</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Production Gallery */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Inside Our Facility</h2>
            <p className="text-xl text-gray-600">A glimpse into our modern manufacturing processes and quality control systems</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="relative overflow-hidden rounded-xl shadow-lg group">
              <img 
                src="https://readdy.ai/api/search-image?query=light%20magnesium%20carbonate%20production%20line%2C%20chemical%20manufacturing%20equipment%2C%20industrial%20machinery%2C%20powder%20processing%20plant%2C%20automated%20production%20system%2C%20clean%20manufacturing%20environment&width=400&height=300&seq=sgc-production&orientation=landscape"
                alt="Production Line"
                className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <h3 className="text-white font-semibold text-lg">Production Line</h3>
                <p className="text-gray-200 text-sm">Advanced manufacturing equipment</p>
              </div>
            </div>
            
            <div className="relative overflow-hidden rounded-xl shadow-lg group">
              <img 
                src="https://readdy.ai/api/search-image?query=chemical%20quality%20control%20laboratory%2C%20testing%20equipment%2C%20analysis%20instruments%2C%20laboratory%20technician%20working%2C%20scientific%20testing%20facility%2C%20quality%20assurance%20lab&width=400&height=300&seq=sgc-lab&orientation=landscape"
                alt="Quality Control Lab"
                className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <h3 className="text-white font-semibold text-lg">Quality Control Lab</h3>
                <p className="text-gray-200 text-sm">Rigorous testing protocols</p>
              </div>
            </div>
            
            <div className="relative overflow-hidden rounded-xl shadow-lg group">
              <img 
                src="https://readdy.ai/api/search-image?query=light%20magnesium%20carbonate%20powder%20samples%2C%20white%20crystalline%20powder%2C%20high%20purity%20chemical%20product%2C%20product%20packaging%2C%20quality%20testing%20samples%2C%20professional%20product%20display&width=400&height=300&seq=sgc-product&orientation=landscape"
                alt="Final Product"
                className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <h3 className="text-white font-semibold text-lg">Final Product</h3>
                <p className="text-gray-200 text-sm">Premium magnesium carbonate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
